
(function() {
  var module = {};
  var result = {};
  module.exports = { "da": { "i18n": { "duration": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t.", "hoursAndMinutes": "{{ hours }}t. {{ minutes }}min.", "days": "{{ days }}dg", "shortForm": { "seconds": "{{ seconds }}sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t", "days": "{{ days }}dg", "hoursAndMinutes": "{{ hours }}t {{ minutes }}min." } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "Maj", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Okt", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}}{{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "da": "static-7.446"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.446",
    "da": "static-7.446",
    "de": "static-7.446",
    "el": "static-7.446",
    "en": "static-7.446",
    "es-mx": "static-7.446",
    "es": "static-7.446",
    "fi": "static-7.446",
    "fr": "static-7.446",
    "it": "static-7.446",
    "ja": "static-7.446",
    "ko": "static-7.446",
    "nl": "static-7.446",
    "no": "static-7.446",
    "pl": "static-7.446",
    "pt-br": "static-7.446",
    "sv": "static-7.446",
    "zh-cn": "static-7.446",
    "zh-hk": "static-7.446"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:da', {version: 'static-7.446'}); }
})();


